import { auth, db } from "../config/firebase";
import { ref, set, remove } from "firebase/database";
import { getFunctions, httpsCallable } from "firebase/functions";

export const createUserInCompany = async (email, password, role) => {
  const fn = httpsCallable(getFunctions(), "createCompanyUser");
  const result = await fn({ email, password, role });

  return result.data;
};

export const updateUserRole = async (companyId, uid, newRole) => {
  await set(ref(db, `users/${uid}/role`), newRole);
  await set(ref(db, `companies/${companyId}/users/${uid}/role`), newRole);
};

export const deleteUser = async (uid) => {
  const fn = httpsCallable(getFunctions(), "deleteCompanyUser");
  const result = await fn({ uid });
  return result.data;
};